import React from 'react'
import './gammaddaUniverse.css';
import madala from '../../assets/images/image-39-5.png';
import door_to_door from '../../assets/images/image-48.png';
import gammadda_web from '../../assets/images/Gammadda_WEB.png';
import saviya from '../../assets/images/image-50.png';
import v_force from '../../assets/images/64b63b1d6f0d83550382a387_V-FORCE-NEW-LOGO-1-p-500.png';
import wewa from '../../assets/images/image-51.png';
import negitimu from '../../assets/images/image-52.png';
import foreign from '../../assets/images/image-53.png';
import tech_bus from '../../assets/images/image-55.png';
import sanskruthika from '../../assets/images/image-56.png';
import dam_saviya from '../../assets/images/image-57.png';
import voice from '../../assets/images/image-58.png';
import GAMMADDA_THAKSALAWA_LOGO from '../../assets/images/GAMMADDA_THAKSALAWA_LOGO.JPG';
import GILC_LOGO_ENGLISH_min from '../../assets/images/GILC-LOGO-ENGLISH-min.png';
import Rectangle from '../../assets/images/Rectangle-86.png';
import Rectangle_84 from '../../assets/images/Rectangle-84.png';
import Gammadda_Project from '../../assets/images/5fcb4a0799fc03c147f6ae08_Gammadda-Project-2-1-1.png';
import Saviya_Logo from '../../assets/images/Saviya-Logo-1-1.jpg';
import Rectangle_77 from '../../assets/images/Rectangle-57.png';


const GammaddaUniverse = () => {
  return (
    <div className="background-color">
      <div className="container-fluid">
        <div className="row">
          <a href="#janatha" className="universe-blocks w-inline-block col-3"><img src={madala} loading="lazy" alt="" className="image-14 img" /></a>
          <a href="#doortodoor" className="universe-blocks w-inline-block col-3"><img className="img" src={door_to_door} loading="lazy" alt="" /></a>
          <a href="#projects" className="universe-blocks w-inline-block col-3"><img className="img" src={gammadda_web} loading="lazy" alt="" /></a>
          <a href="#saviya" className="universe-blocks w-inline-block col-3"><img className="img" src={saviya} loading="lazy" alt="" /></a>
          <a href="#vforce" className="universe-blocks w-inline-block col-3"><img src={v_force} loading="lazy" alt="" className="v-force img" /></a>
          <a href="#wawen" className="universe-blocks w-inline-block col-3"><img className="img" src={wewa} loading="lazy" alt="" /></a>
          <a href="#nagitamu" className="universe-blocks w-inline-block col-3"><img className="img" src={negitimu} loading="lazy" alt="" /></a>
          <a href="#foreign" className="universe-blocks w-inline-block col-3"><img className="img" src={foreign} loading="lazy" alt="" /></a>
          <a href="#tech" className="universe-blocks w-inline-block col-3"><img className="img" src={tech_bus} loading="lazy" alt="" /></a>
          <a href="#cultural" className="universe-blocks w-inline-block col-3"><img className="img" src={sanskruthika} loading="lazy" alt="" /></a>
          <a href="#dhamsaviya" className="universe-blocks w-inline-block col-3"><img className="img" src={dam_saviya} loading="lazy" alt="" /></a>
          <a href="#voice" className="universe-blocks w-inline-block col-3" ><img className="img" src={voice} loading="lazy" alt="" /></a>
          <a href="#thaksalawa" className="universe-blocks w-inline-block col-3"><img className="img" src={GAMMADDA_THAKSALAWA_LOGO} loading="lazy" alt="" /></a>
          <a href="#gilc" className="universe-blocks w-inline-block col-3"><img className="img" src={GILC_LOGO_ENGLISH_min} loading="lazy" alt="" /></a>
        </div>
      </div>
      <div className="section">
        <div className="container">
          <h1 className="gm-heading-1">Gammadda Universe</h1>
          <p>Founded and conceptualised by Mr. R. Rajamahendran<br />
            <br />Gammadda has become one of the largest humanitarian initiatives in Sri Lanka and has become a case study for community driven rural development, volunteerism, Community services, Disaster mitigation, Preparedness and relief, Education services and promotion of Arts and culture . </p>
        </div>
      </div>
      <div id="janatha" className="section">
        <div className="container">
          <div className="row janatham">
            <div className='col-md-6'>
              <img className="img" src={Rectangle} alt="" />
            </div>

            <div className="col-md-6 content-wrapper-universe">
              <h3 className="h3-universe">Janatha Mandapaya</h3>
              <p className="p-left universe">&quot;Speak your mind, for the Country to Hear&quot;: Gammadda was first introduced as a public forum initiative held in rural villages. The objective of this attempt was to identify issues that are hidden below the surface and bring the attention of responsible authorities towards these issues faced by Sri Lankans. Gammadda Janatha Mandapaya empowers residents to hold their elected representatives accountable in front of a national audience.</p>
            </div>
          </div>
        </div>
      </div>
      <div id="doortodoor" className="section">
        <div className="container">
          <div className="row">
            <div id="w-node-_5c0f80de-c708-2e4c-265e-9155880fd35c-82f57a24" className="col-md-6 order-md-first order-last content-wrapper-universe">
              <h3 className="h3-universe">Gammadda Door to Door</h3>
              <p className="p-left universe">Sri Lanka is known as a paradise island all around the world. From breathtaking mountain views, tranquil beaches, thousands of years of history and an exquisite culture, we really do seem to have it all. However, a deeper understanding of Sri Lanka reveals the unhappy truth, that more than 75% of our population is in fact, rural, struggling and in need of help. Countless tired but smiling faces would tell you the daily struggle to find the most basic needs to live for today. <br /><br />At Gammadda we do not believe Sri Lanka is a poor country- rather it is unequal. </p>          <a href="research-and-data" className="button universe">Learn more</a>
            </div>
            <div className='col-md-6 order-md-last order-first'>
              <img className="img" src={Rectangle_84} alt="" />
            </div>

          </div>
        </div>
      </div>
      <div id="projects" className="section">
        <div className="container">
          <div className="row projects">
            <div className='col-md-6'>
              <img className="img" src={Gammadda_Project} alt="" />
            </div>

            <div className="col-md-6 content-wrapper-universe">
              <h3 className="h3-universe">Gammadda Projects</h3>
              <p className="p-left universe">Gammadda projects aims at alleviating poverty, uplifting social and economic standards, enhancing livelihoods, and improving cultural diversity and dialouge between communities. Gammadda projects are focused on community driven rural development.</p>
              <a href="projects-prospective" className="button universe">Learn more</a>
            </div>
          </div>
        </div>
      </div>
      <div id="saviya" className="section universe">
        <div className="container">
          <div className="row saviya">
            <div className="col-md-6 content-wrapper-universe  order-md-first order-last">
              <h3 className="h3-universe">Gammadda Saviya</h3>
              <p className="p-left universe">Gammadda Saviya Societies are formed with local community members to ensure project sustainability. Gammadda Saviya members are delegated the task of maintaining projects vested in their communities. Gammadda Saviya societies also identify local community issues and collaborate with the Gammadda team to find speedy solutions.</p>
              <a href="https://www.google.com/maps/d/u/0/edit?mid=1UzmAtYW6aschPAUFhdttUGDNDCaBrzCC&amp;usp=sharing" target="_blank" className="button universe">Our Footprint</a>
            </div>
            <div className='col-md-6  order-md-last order-first'>
              <img className="img" src={Saviya_Logo} height="500" />
            </div>

          </div>
        </div>
      </div>
      <div id="vforce" className="section universe">
        <div className="container">
          <div className="row vforceg">
            <div className='col-md-6'>
              <img className="img" src={Rectangle_77} alt="" />
            </div>
            <div className="col-md-6 content-wrapper-universe">
              <h3 className="h3-universe">Gammadda V-Force</h3>
              <p className="p-left universe">A platform for the youth of this country to place the interests of the country before their own, and volunteer for a worthy cause.</p>
              <a href="gammadda-volunteering" className="button universe">Learn more</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GammaddaUniverse